import { render, staticRenderFns } from "./resultAnalysis.vue?vue&type=template&id=81b484f0&"
import script from "./resultAnalysis.vue?vue&type=script&lang=js&"
export * from "./resultAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./resultAnalysis.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports